module.exports = __webpack_public_path__ + "img/logo.12c4bc4f.png";